import React, { Component } from 'react'
import Review from '../components/Review'
import RequestList from '../components/RequestList'
import PropTypes from "prop-types";
import { withRouter } from "react-router";

const URL_PATH_PREFIX = '/review/';
export class ReviewPage extends Component {

    state = {
        requestId: 0,
        token: "",
        approver: "",
        disabled: false
    }

    componentDidMount() {
        this.retrieveUrlParams();
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component    
        this.setState = (state, callback) => {
            return;
        };
    }

    retrieveUrlParams = () => {
        const query = new URLSearchParams(this.props.location.search);
        let id = query.get('id');
        let token = query.get('token');
        let approver = query.get('token2');
        if (id) {
            this.setState({
                requestId: id,
                token: token,
                approver: approver
            }, () => {
                //Save to local storage
                localStorage.setItem(token, JSON.stringify({id: id, approver: approver}));

                //rewrite url to look nicer
                this.props.history.push(URL_PATH_PREFIX + token);
            });
        } else {
            const path = this.props.location.pathname;
            if (path.startsWith(URL_PATH_PREFIX)) {
                token = path.substring(8);
                const idStored = JSON.parse(localStorage.getItem(token));
                if (idStored && idStored.id) {
                    id = parseInt(idStored.id);
                    approver = idStored.approver;
                } else {
                    // invalid link
                    this.props.history.push('/error/80000');                    
                }
            }
            this.setState({
                requestId: id,
                token: token,
                approver: approver
            });
        }

        this.setState({
            disabled: token === null || token.trim() === ''
        }, () => {
            // console.log("[token]", token);
            // console.log("[disabled]", this.state.disabled);
        });
    }


    render() {

        return (
            <div>
                {this.state.disabled ? <div className="disabled-div"></div> : null}
                <Review
                    requestId={this.state.requestId}
                    token={this.state.token}
                    approver={this.state.approver} 
                ></Review>
            </div>
        )
    }


}

export default withRouter(ReviewPage)
